export const MOBILE = 'MOBILE';
export const DESKTOP = 'DESKTOP';
export const LOADED = 'LOADED';
export const OPEN = 'OPEN';
export const CLOSED = 'CLOSED';
export const SET_LOCATION = 'SET_LOCATION';
export const NAVIGATION_HISTORY = 'NAVIGATION_HISTORY';
export const SET_ERROR = "SET_ERROR";
export const HIDE_ERROR = "HIDE_ERROR";
export const SET_CURRENT_USER = "SET_CURRENT_USER";